module.exports = __webpack_public_path__ + "static/circle-semi-2-c162d54fbba059c006837429a82fea0e.png";